/*  global jQuery, $  */
jQuery(document).ready(function () {
  // 手機側邊選單
  $('nav#menu').mmenu({
    drag: true,
    pageScroll: {
      scroll: true,
      update: true
    },
    'extensions': [
      'theme-dark',
      'fx-menu-fade',
      'fx-listitems-slide'
    ]
  }, {
    classNames: {
      fixedElements: {
        fixed: 'fix',
        sticky: 'sticky-top'
      }
    }
  })
  // Header Sticker
  // $('#pageHeader').sticky({topSpacing: 0})
  // $('#pageHeader').on('sticky-end', function () { $(this).parent('.sticky-wrapper').css({height: 'auto'}) }) // sticky 補丁
  // $('#pageHeader').on('sticky-start', function () { $(this).addClass('is-sticky fixed animated fadeInDown') });
  // $('#pageHeader').on('sticky-end', function () { $(this).removeClass('is-sticky fixed animated fadeInDown') });
  // Header 捲動

  $(window).bind('scroll', function () {
    var top = 100;
    if ($(document).scrollTop() > top) {
      $('#pageHeader').addClass('is-sticky fixed animated fadeInDown')
    } else {
      $('#pageHeader').removeClass('is-sticky fixed animated fadeInDown')
    }
  })

  AOS.init();

  // function warmingBarFixed() {
  //   var h = $('#warningContainer').outerHeight()
  //   $('#footer').css('margin-bottom',h)
  //   console.log('高度'+h);
  // }
  // warmingBarFixed()

  $('.dropdown-hover').dropdownHover(100)

  $('#heroBanner').slick({
    dots: true,
    infinite: true,
    speed: 600
  });

  $().UItoTop({ easingType: 'easeOutQuart', text: '<i class="icon-up-small"></i>' })

  $('.lazy').Lazy()

  $('.slick-slider').hover(function () {
    var _this = $(this)
    _this.find('.slick-next').addClass("animated bounceInRight")
    _this.find('.slick-prev').addClass("animated bounceInLeft")
  })

  // $('#collectionsMenu').sapling({
  //   multiexpand: true,
  //   animation: true
  // });

  const CategorySlider = $("#categoryLists");
  CategorySlider
    .slick({
      slidesToShow: 6,
      slidesToScroll: 3,
      infinite: true,
      dots: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 3,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });

  let contactInputs = document.querySelectorAll('.contact-input')
  for (let i = 0; i < contactInputs.length; i++) {
    contactInputs[i].addEventListener('change', inputFocus, {passive: false});
  }
  function inputFocus(e) {
    if (e.target.value.length != 0) {
      e.target.classList.add('focus')
    } else {
      e.target.classList.remove('focus')
    }
  }

  // CategorySlider.on('wheel', (function (e) {
  //   e.preventDefault();
  //   if (e.originalEvent.deltaY < 0) {
  //     $(this).slick('slickNext');
  //   } else {
  //     $(this).slick('slickPrev');
  //   }
  // }));








});


